import React, { useState, useEffect, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import FormAlert from "./Shared/FormAlert";
import LanguageToggle from "./Shared/LanguageToggle";
import cognitoAuthService from "../../services/cognitoAuthService";
import { LOGO_URL } from "../../constants";
import "../../styles/auth.css";

const isValidEmail = (email) => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);

const ConfirmUser = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const calledRef = useRef(false);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const clientId = searchParams.get("client_id") || "";
  const userName = searchParams.get("user_name") || "";
  const confirmationCode = searchParams.get("confirmation_code") || "";
  const tenantId = searchParams.get("tenant_id") || "";
  const email = (searchParams.get("email") || "").replace(/ /g, "+");

  useEffect(() => {
    if (calledRef.current) return;
    calledRef.current = true;

    if (!clientId || !userName || !confirmationCode || !tenantId || !email) {
      setError(t("confirmUser.missingParams"));
      setLoading(false);
      return;
    }

    if (!isValidEmail(email)) {
      setError(t("confirmUser.invalidEmail"));
      setLoading(false);
      return
    }

    cognitoAuthService
      .confirmUserByLink({ tenantId, clientId, userName, confirmationCode, email })
      .then(() => {
        setSuccess(true);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message || t("confirmUser.confirmationFailed"));
        setLoading(false);
      });
  }, [clientId, userName, confirmationCode, tenantId, email, t]);

  return (
    <div className="login-page">
      <div className="brand-header">
        <img src={LOGO_URL} alt="Logo" className="brand-logo" />
      </div>
      <div className="login-card">
        <LanguageToggle />
        <div className="form-container">
          <h3>{t("confirmUser.title")}</h3>

          {loading && !error && (
            <div className="loading-state">
              <span className="spinner"></span>
              <p className="info-text">{t("confirmUser.confirming")}</p>
            </div>
          )}

          {!loading && error && !success && (
            <>
              <FormAlert type="error" message={error} />
              <button
                className="btn btn-primary"
                onClick={() => navigate("/login")}
              >
                {t("confirmUser.backToSignIn")}
              </button>
            </>
          )}

          {!loading && success && (
            <>
              <FormAlert type="success" message={t("confirmUser.success")} />
              <button
                className="btn btn-primary"
                onClick={() => navigate("/login")}
              >
                {t("confirmUser.backToSignIn")}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfirmUser;
